module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-regal-05.365df0cd.jpeg";